var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.82 12.43c0-.2.08-.39.22-.53L12.4.54a.75.75 0 0 1 1.06 0l4.14 4.14c.29.3.29.77 0 1.06L6.24 17.1a.75.75 0 0 1-.54.22H1.57a.75.75 0 0 1-.75-.75v-4.14Zm1.5.31v3.08h3.07l8.35-8.35-3.08-3.07-8.34 8.34Zm9.4-9.4L14.8 6.4 16 5.2l-3.07-3.08-1.2 1.2Z",
    clipRule: "evenodd",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.20ff0624f437609a7b0efb18d1ddb114.svg";
export { ForwardRef as ReactComponent };